import React from 'react';

const Contacts = () => {
  return <h1>Contact</h1>
}

export default Contacts